import type { Airflow } from '@aviata/platform-types';
import { compact } from 'lodash-es';

export function getOfferSeatsLeft(offer: Airflow.Offer.Entity) {
  const SCAT_AIRLINE_CODE = 'DV';

  /**
   * We should show seats left only if there are less than 9 seats left
   */
  const SEATS_LEFT_THRESHOLD = 9;

  /**
   * For SCAT, we should show seats left only if there are less than 4 seats left
   * This is business requirement for SCAT only
   */
  const SCAT_SEATS_LEFT_THRESHOLD = 4;

  const seatsLeft = offer.flights
    .flatMap(itinerary => itinerary.segments)
    .flatMap(segment => {
      return compact(Object.values(segment.fare)).filter(fare => {
        return segment.airline === SCAT_AIRLINE_CODE
          ? fare.seats > 0 && fare.seats < SCAT_SEATS_LEFT_THRESHOLD
          : fare.seats > 0 && fare.seats < SEATS_LEFT_THRESHOLD;
      });
    })
    .reduce((min, fare) => Math.min(min, fare.seats), Infinity);

  return seatsLeft === Infinity ? null : seatsLeft;
}
